import { Api } from "@/config";
import Subscription from "@/models/subscription";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import { SubscriptionStatus } from "@/models/subscriptionStatus";
import moment from "moment";
import SubscriptionPlan from "@/models/subscriptionPlan";
import AppSettings from "@/appsettings";
import {
  SET_SUBSCRIPTIONS,
  SET_SUBSCRIPTION_PLAN_PRICING,
} from "@/store/mutation-types";

@Module({ namespaced: true })
export default class Subscriptions extends VuexModule {
  public subscriptions: Array<Subscription> = [];
  public subscriptionPlans: Array<SubscriptionPlan> =
    AppSettings.AvailableSubscriptions;

  //#region Actions
  //
  // Get all subscriptions (active/cancelled)
  // for the logged in user
  @Action
  public getSubscriptions(): Promise<void> {
    return new Promise((resolve, reject) => {
      Api.get(`subscriptions`).then(
        (response) => {
          if (response && response.status === 200) {
            let subscriptions: Array<Subscription> = [];

            response.data.forEach((subscription: any) => {
              subscriptions.push(new Subscription(subscription));
            });

            this.context.commit(SET_SUBSCRIPTIONS, subscriptions);
          }

          resolve();
        },
        (error) => {
          reject(error.response);
        }
      );
    });
  }
  //#endregion

  //#region Getters
  // An active subscription is either:
  // SubscriptionStatus.Active
  // SubscriptionStatus.Trialing
  // SubscriptionStatus.Deleted WITH cancellationEffectiveDate in the FUTURE
  get activeSubscription() {
    let subscriptions = this.subscriptions.filter(
      (s) =>
        s.status === SubscriptionStatus.Active ||
        s.status === SubscriptionStatus.Trialing ||
        (s.status === SubscriptionStatus.Deleted &&
          moment().isBefore(moment(s.cancellationEffectiveDate)))
    );

    if (subscriptions.length) {
      return subscriptions[0];
    }

    return null;
  }

  get pausedSubscription() {
    let subscriptions = this.subscriptions.filter(
      (s) => s.status === SubscriptionStatus.Paused
    );

    if (subscriptions.length) {
      return subscriptions[0];
    }

    return null;
  }

  get hasPausedSubscription(): boolean {
    const subscriptions = this.subscriptions.filter(
      (s) => s.status === SubscriptionStatus.Paused
    );

    return subscriptions.length ? true : false;
  }

  get hasActiveSubscription(): boolean {
    return this.activeSubscription != null;
  }
  //#endregion

  //#region Mutations
  @Mutation
  public [SET_SUBSCRIPTIONS](value: Array<Subscription>) {
    this.subscriptions = value;
  }

  @Mutation
  public [SET_SUBSCRIPTION_PLAN_PRICING](
    subscriptionPricing: SubscriptionPlan
  ) {
    let subscriptionPlan = this.subscriptionPlans.find(
      (s) => s.id == subscriptionPricing.id
    );

    if (subscriptionPlan) {
      subscriptionPlan.setData(subscriptionPricing);
    }
  }
  //#endregion
}
